import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

const PreviousAddressForm = ({
  initialValues,
  values,
  errors,
  touched,
  getStates,
  handleChange,
  handleBlur,
  handleIncomeBlur,
  handleCurrencyFormat,
  selectedResidenceLengthValue,
  ...props
}) => {
  return (
    <React.Fragment>
      {selectedResidenceLengthValue && selectedResidenceLengthValue.value == 1 ? (
          
        <>
          <Input
            type="hidden"
            id="income_desc"
            name="income_desc"
            value={""}
          />
          <Row>
            <Col lg="6">
            <FormGroup className="mb-3">
              <Label for="prev_addr">Previous Address</Label>
                <Input
                  type="text"
                  className="form-control"
                  id="prev_addr"
                  name="prev_addr"
                  placeholder="Enter Applicant Previous Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.prev_addr || ""}
                  invalid={
                    touched.prev_addr &&
                    errors.prev_addr
                      ? true
                      : false
                  }
                />
                {touched.prev_addr &&
                errors.prev_addr && (
                  <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.prev_addr}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup className="mb-3">
                <Label for="prev_city">Previous City</Label>
                <Input
                  type="text"
                  className="form-control"
                  id="prev_city"
                  name="prev_city"
                  placeholder="Enter Applicant Previous City"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.prev_city || ""}
                  invalid={
                    touched.prev_city &&
                    errors.prev_city
                      ? true
                      : false
                  }
                />
                  {touched.prev_city && errors.prev_city && (
                    <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                      {errors.prev_city}
                    </FormFeedback>
                  )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
            <FormGroup className="mb-3">
              <Label>Previous State</Label>
              <Select
                  id="prev_state"
                  name="prev_state"
                  placeholder="Select Previous State"
                  defaultValue={values.prev_state}
                  value={values.prev_state}
                  onChange={selectedOption => {
                    let event = {
                      target: {
                        name: "prev_state",
                        value: selectedOption,
                      },
                    }
                    handleChange(event)
                  }}
                  isSearchable={true}
                  options={getStates()}
                  isLoading={false}
                  loadingMessage={() => "loading states"}
                  noOptionsMessage={() => "states"}
                  invalid={
                    touched.prev_state &&
                    errors.prev_state &&
                    errors.prev_state.value
                      ? true
                      : false
                  }
                />
                {touched.prev_state &&  errors.prev_state && errors.prev_state.value && (
                  <FormFeedback
                    type="invalid"
                    style={{ display: "block", fontSize: "100%" }}
                  >
                    {errors.prev_state.value}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
            <Col lg="6">
              <FormGroup className="mb-3">
              <Label for="prev_zip">Previous Zipcode</Label>
                <Input
                  type="text"
                  className="form-control"
                  id="prev_zip"
                  name="prev_zip"
                  placeholder="Enter Applicant Previous Zipcode"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.prev_zip || ""}
                  invalid={ 
                    touched.prev_zip && errors.prev_zip
                    ? true
                    : false
                  }
                />
                {touched.prev_zip && errors.prev_zip && (
                  <FormFeedback type="invalid" style={{ fontSize: "100%" }}>
                    {errors.prev_zip}
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>

        </>
      ) : (selectedResidenceLengthValue && selectedResidenceLengthValue.value != 1 && (
        <>
          {/* Hidden Inputs */}
          <Input
              type="hidden"
              id="prev_addr"
              name="prev_addr"
              value={""}
            />
            <Input
              type="hidden"
              id="prev_city"
              name="prev_city"
              value={""}
            />
            <Input
              type="hidden"
              id="prev_state"
              name="prev_state"
              value={""}
            />
            <Input
              type="hidden"
              id="prev_zip"
              name="prev_zip"
              value={""}
            />
        </>

      ))
    }
    </React.Fragment>
  )
}

export default PreviousAddressForm 
